import type { PublicApiKey } from '#packages/apilib';
import type { createPrivateAppsPanelApi } from './api';

export const PrivateAppsPanelApiKey: PublicApiKey<
  typeof createPrivateAppsPanelApi
> = {
  name: 'PrivateAppsPanelApi',
  public: true,
};
